import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import {
  Box, MenuItem, Paper, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TextField, Typography,
} from "@material-ui/core";
import { useNotify } from "react-admin";
import { cloError, cloGet, ENDPOINTS, formatDate } from "./api";

const ENTITIES = ["retailer", "mid", "campaign", "campaign_version", "campaign_offer"];

const short = (value: any): string => {
  if (value === null || value === undefined) return "—";
  const text = typeof value === "string" ? value : JSON.stringify(value);
  return text.length > 160 ? `${text.slice(0, 160)}…` : text;
};

const AuditTab: React.FC = () => {
  const notify = useNotify();
  const [rows, setRows] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [entity, setEntity] = useState("");
  const [entityId, setEntityId] = useState("");
  const [actor, setActor] = useState("");

  const load = useCallback(async () => {
    try {
      const res = await cloGet(ENDPOINTS.CLO_AUDIT, {
        page: page + 1, pageSize, entity: entity || undefined, entityId: entityId || undefined, actor: actor || undefined,
      });
      setRows(res.data || []);
      setTotal(res.pagination?.total || 0);
    } catch (e) {
      notify(cloError(e), "warning");
    }
  }, [page, pageSize, entity, entityId, actor, notify]);

  useEffect(() => {
    const t = setTimeout(load, 300);
    return () => clearTimeout(t);
  }, [load]);

  return (
    <Paper>
      <Box p={2} display="flex" style={{ gap: 12 }}>
        <TextField select size="small" variant="outlined" label="Entity" value={entity} onChange={(e) => setEntity(e.target.value)} style={{ minWidth: 180 }}>
          <MenuItem value="">All</MenuItem>
          {ENTITIES.map((e) => <MenuItem key={e} value={e}>{e}</MenuItem>)}
        </TextField>
        <TextField size="small" variant="outlined" label="Entity ID" value={entityId} onChange={(e) => setEntityId(e.target.value)} />
        <TextField size="small" variant="outlined" label="Who" value={actor} onChange={(e) => setActor(e.target.value)} />
      </Box>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>When</TableCell>
            <TableCell>Who</TableCell>
            <TableCell>Action</TableCell>
            <TableCell>Entity</TableCell>
            <TableCell>Version</TableCell>
            <TableCell>Before</TableCell>
            <TableCell>After</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((r) => (
            <TableRow key={r.id}>
              <TableCell>{formatDate(r.createdAt)}</TableCell>
              <TableCell>{r.actor}</TableCell>
              <TableCell>{r.action}</TableCell>
              <TableCell>{r.entity} #{r.entity_id}</TableCell>
              <TableCell>{r.version ?? "—"}</TableCell>
              <TableCell><Typography variant="caption">{short(r.before)}</Typography></TableCell>
              <TableCell><Typography variant="caption">{short(r.after)}</Typography></TableCell>
            </TableRow>
          ))}
          {rows.length === 0 && (
            <TableRow><TableCell colSpan={7} align="center">No entries</TableCell></TableRow>
          )}
        </TableBody>
      </Table>
      <TablePagination
        component="div" count={total} page={page} rowsPerPage={pageSize}
        onChangePage={(_, p) => setPage(p)}
        onChangeRowsPerPage={(e) => { setPageSize(Number(e.target.value)); setPage(0); }}
      />
    </Paper>
  );
};

export default AuditTab;
